


















































import Vue from 'vue';
import { ESalutation } from '@ringana/configs';
import TIcons from '@/types/TIcons';
import CustomButton from '@/components/layout/buttons/CustomButton.vue';
import ValidationHelper from '@/helpers/ValidationHelper';
import { IApiUnsubscribeNewsletterData } from '@/common/interfaces/api.interface';

interface IUnsubscribeNewsletterComponent {
  $refs?: {
    footerLink: HTMLDivElement;
    modal?: HTMLDivElement;
    unsubscribeInput?: HTMLInputElement;
  };
  email: string;
  icons: typeof TIcons;
  loading: boolean;
  modalFeedback: {
    isError: boolean;
    message: string;
  };
  modalVisible: boolean;
}

export default Vue.extend({
  name: `UnsubscribeNewsletter`,
  components: { CustomButton },
  data(): IUnsubscribeNewsletterComponent {
    return {
      email: ``,
      icons: TIcons,
      loading: false,
      modalFeedback: {
        isError: false,
        message: ``,
      },
      modalVisible: false,
    };
  },
  methods: {
    closeModal(): void {
      this.email = ``;
      this.modalFeedback.message = ``;
      this.modalVisible = false;
      this.$refs.footerLink.focus();
    },
    async unsubscribeNewsletter(): Promise<void> {
      if(!ValidationHelper.isEmail(this.email)) {
        this.modalFeedback.isError = true;
        this.modalFeedback.message = this.$t(`footer:unsubscribeNewsletter.validEmailMessageText`);
        return;
      }

      this.loading = true;

      const data: IApiUnsubscribeNewsletterData = {
        email: this.email,
        salutationId: ESalutation.MR,
      };

      try {
        if(!await this.$apiService.unsubscribeNewsletter({ data })) {
          this.modalFeedback.isError = true;
          this.modalFeedback.message = ``;
          return;
        }
        this.modalFeedback.isError = false;
        this.modalFeedback.message = this.$t(`footer:unsubscribeNewsletter.youWillReceiveText`);
      } catch (err) {
        this.modalFeedback.isError = true;
        this.modalFeedback.message = ``;
      }

      this.loading = false;
    },
  },
  watch: {
    modalVisible: {
      handler() {
        this.$nextTick(() => {
          if(this.$refs.unsubscribeInput) {
            this.$refs.unsubscribeInput.focus();
          }
        });
      },
    },
  },
});
